import React from "react";
import { LogOut, Users } from "lucide-react";
import NotificationsPanel from "./NotificationsPanel";
import "../../styles/Header.css";

const Header = ({
  user,
  userRole,
  schools,
  selectedSchool,
  onSchoolChange,
  onLogout,
  schoolRole,
  onOpenUserManagement,
}) => {
  const selectedSchoolData = schools.find((s) => s.id === selectedSchool);

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <img
            src="/images/iconik-studio-schools-logo.png"
            alt="Iconik Studio Schools"
            className="logo-image"
          />
          <h1 className="title">School Photo Management</h1>
        </div>

        {/* Show school selector for studio users and multi-school users */}
        {userRole === "studio" ? (
          <div className="school-selector">
            <span className="school-label">School:</span>
            <select
              value={selectedSchool || ""}
              onChange={(e) => onSchoolChange(e.target.value)}
              className="school-select"
            >
              <option value="">Select a school...</option>
              {schools.map((school) => (
                <option key={school.id} value={school.id}>
                  {school.name}
                </option>
              ))}
            </select>
          </div>
        ) : user?.schools && user.schools.length > 1 ? (
          /* For multi-school users, show a dropdown to switch between their schools */
          <div className="school-selector">
            <span className="school-label">School:</span>
            <select
              value={selectedSchool || ""}
              onChange={(e) => onSchoolChange(e.target.value)}
              className="school-select"
            >
              {user.schools.map((schoolAccess) => {
                const schoolData = schools.find(s => s.id === schoolAccess.schoolId);
                return (
                  <option key={schoolAccess.schoolId} value={schoolAccess.schoolId}>
                    {schoolData?.name || schoolAccess.schoolId} ({schoolAccess.role.replace('school-', '')})
                  </option>
                );
              })}
            </select>
          </div>
        ) : (
          /* For single school users, show their school name as read-only */
          selectedSchoolData && (
            <div className="school-selector">
              <span className="school-label">School:</span>
              <div className="school-select school-select-readonly">
                {selectedSchoolData.name}
              </div>
            </div>
          )
        )}

        <div className="user-info">
          {/* Notifications Panel - Only for studio users */}
          <NotificationsPanel user={user} userRole={userRole} />

          {/* Manage Users button for school admins */}
          {schoolRole === "school-admin" && selectedSchool && (
            <button onClick={onOpenUserManagement} className="button button-primary">
              <Users style={{ width: "16px", height: "16px" }} />
              Manage Users
            </button>
          )}

          <span className="user-text">
            {user.email} ({userRole})
          </span>
          <button onClick={onLogout} className="button button-danger">
            <LogOut style={{ width: "16px", height: "16px" }} />
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
